import { combineReducers } from "redux";

import authStoreReducer from "./authStore";
import apiStoreReducer from "./apiStore";
import commonStoreReducer from "./commonStore";

const rootReducer = combineReducers({
  auth: authStoreReducer,
  apis: apiStoreReducer,
  common: commonStoreReducer,
});

export default rootReducer;
